import { useEffect, useState } from "react";
import {useNavigate,useParams,useLocation,} from "react-router-dom";
import Card from "../components/Card";

export default function McqHome() {
  const navigate = useNavigate();
  const location = useLocation();

  // Dynamic feature
  const flowType =
    location.state?.feature ??
    localStorage.getItem("flow_type") ??
    "mcq";

  const { id } = useParams();

  const gradeId =
    id ||
    localStorage.getItem("selected_grade");


  const selectedStream =
    localStorage.getItem("selected_stream");

  const [subjects, setSubjects] =
    useState([]);

  /* ================= NAVBAR ================= */

  useEffect(() => {
    const navbar =
      document.querySelector(".navbar");

    const handleScroll = () => {
      const currentScroll =
        window.pageYOffset;

      if (!navbar) return;

      if (currentScroll <= 10) {
        navbar.style.transform =
          "translateX(-50%) translateY(0)";
        navbar.style.opacity = "1";
      } else {
        navbar.style.transform =
          "translateX(-50%) translateY(-130%)";
        navbar.style.opacity = "0";
      }
    };

    if (navbar) {
      navbar.style.position = "fixed";
      navbar.style.top = "15px";
      navbar.style.left = "50%";
      navbar.style.width = "90%";
      navbar.style.maxWidth = "1100px";
      navbar.style.transform =
        "translateX(-50%)";
      navbar.style.zIndex = "9999";
      navbar.style.transition =
        "all 0.35s ease";
    }

    window.addEventListener(
      "scroll",
      handleScroll
    );

    return () => {
      window.removeEventListener(
        "scroll",
        handleScroll
      );

      if (navbar) {
        navbar.style.transform =
          "translateX(-50%) translateY(0)";
        navbar.style.opacity = "1";
      }
    };
  }, []);

  /* ================= LOAD SUBJECTS ================= */
  useEffect(() => {

    if (!gradeId) return;

    // Grade 12 / 13 only
    if (
      (Number(gradeId) === 200013 ||
       Number(gradeId) === 200014) &&
      selectedStream
    ) {

      fetch(
        `https://edunet.kmechengineering.com/root-engine1/api/subjects-by-stream?grade_id=${gradeId}&stream_name=${encodeURIComponent(selectedStream)}`
      )
        .then(res => res.json())
        .then(data => {
          setSubjects(data.subject_data || []);
        })
        .catch(() => {
          setSubjects([]);
        });

    } else {

      fetch(
        `https://edunet.kmechengineering.com/root-engine1/api/subject-by-grade?grade_id=${gradeId}`
      )
        .then(res => res.json())
        .then(data => {
          setSubjects(data.subject_data || []);
        })
        .catch(() => {
          setSubjects([]);
        });

    }

  }, [gradeId, selectedStream]);

  return (
    <div className="mcq-page">
      <h2 className="mcq-title">
        Select Subject
      </h2>

      <div className="card-grid">
        {subjects.map((subject) => (
          <Card
            key={subject.subject_id}
            title={subject.name}
            subtitle={`Start ${flowType}`}
            avatarText="S"
            onClick={() => {
              navigate(
                `/${flowType}/middle/${subject.subject_id}?grade_id=${gradeId}`,
                {
                  state: {
                    feature: flowType,
                  },
                }
              );
            }}
          />
        ))}

        {subjects.length === 0 && (
          <p style={{ color: "#fff" }}>
            No subjects available
          </p>
        )}
      </div>
    </div>
  );
}


